import React from 'react';

const Footer = () => {
    return (
        <footer className="w-full py-4 px-4 mt-auto border-t border-border bg-background/80">
            <div className="max-w-7xl mx-auto text-center text-sm text-muted-foreground">
                <div className="font-medium">通书 Online Tong Shu Plotter</div>
                <div className="mt-1">Copyright © 2026 Steven Yong - Digital Dive Coaching Sdn. Bhd. All rights reserved worldwide.</div>
            </div>
        </footer>
    );
};

export default Footer;
